export default __webpack_public_path__ + "static/media/squiggles-no-1.c748b0b1.mid";